// @ts-nocheck
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  makeStyles,
  Box,
  Drawer,
  Icon,
  IconButton,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../../auth';
import { AppRoute } from '../../constants';

const useStyles = makeStyles(theme => ({
  drawer: {
    width: '240px',
    whiteSpace: 'nowrap',
    flexShrink: '0',
  },
  drawerOpen: {
    width: '240px',
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    width: '80px',
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  drawerListItem: {
    borderRadius: theme.shape.borderRadius,
    width: 'calc(100% - 24px)',
    margin: '0 12px 8px 12px',
    '&.Mui-selected, &.Mui-selected:hover': {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.primary.main,
    },
  },
  icon: {
    minWidth: '50px',
  },
  text: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  logo: {
    width: 'auto',
    height: '40px',
  },
  hide: {
    display: 'none',
  },
}));

function AppDrawer(props) {
  const [t] = useTranslation();
  const currentUser = useSelector(selectCurrentUser);
  const location = useLocation();
  const classes = useStyles();

  const renderDrawerItem = (id, text, icon, path, roles) => {
    const userRoles = _.map(currentUser?.authorities, auth => auth.authority);
    if (roles.some(role => userRoles.includes(role))) {
      const selected = location.pathname.includes(path);
      return (
        <ListItem
          id={`AppDrawer-${id}`}
          className={classes.drawerListItem}
          component={Link}
          to={path}
          selected={selected}
          button
        >
          <ListItemIcon classes={{ root: classes.icon }}>
            <Icon>{icon}</Icon>
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.text }} primary={text} />
        </ListItem>
      );
    }
    return null;
  };

  const { drawerOpen, onDrawerClose } = props;

  return (
    <Drawer
      id="AppDrawer"
      variant="permanent"
      className={clsx(classes.drawer, {
        [classes.drawerOpen]: drawerOpen,
        [classes.drawerClose]: !drawerOpen,
      })}
      classes={{
        paper: clsx({
          [classes.drawerOpen]: drawerOpen,
          [classes.drawerClose]: !drawerOpen,
        }),
      }}
    >
      <Box className={classes.drawerHeader}>
        <img
          src="/tv2_cvi_logo.svg"
          alt="logo"
          className={clsx(classes.logo, {
            [classes.hide]: !drawerOpen,
          })}
        />
        <IconButton
          id="AppDrawer-hideButton"
          className={clsx({
            [classes.hide]: !drawerOpen,
          })}
          onClick={onDrawerClose}
        >
          <Icon>chevron_left</Icon>
        </IconButton>
      </Box>
      <Divider />
      <List>
        {renderDrawerItem('customers', t('nav.customers'), 'search', AppRoute.Customers, [
          'CUSTOMERSERVICE',
          'COMMERCIAL',
        ])}
        {renderDrawerItem('vouchers', t('nav.vouchers'), 'redeem', AppRoute.Vouchers, [
          'CUSTOMERSERVICE',
          'COMMERCIAL',
        ])}
        {renderDrawerItem('campaigns', t('nav.campaigns'), 'card_membership', AppRoute.Campaigns, [
          'COMMERCIAL',
        ])}
        {renderDrawerItem('promotions', t('nav.promotions'), 'percent', AppRoute.Promotions, [
          'CUSTOMERSERVICE',
          'COMMERCIAL',
        ])}
        {renderDrawerItem(
          'serviceMessages',
          t('nav.serviceMessages'),
          'announcement',
          AppRoute.ServiceMessages,
          ['CUSTOMERSERVICE']
        )}
        {renderDrawerItem('companies', t('nav.companies'), 'business', AppRoute.Companies, ['B2B'])}
        {renderDrawerItem('products', t('nav.products'), 'inventory', AppRoute.Products, ['COMMERCIAL'])}
      </List>
    </Drawer>
  );
}

AppDrawer.propTypes = {
  drawerOpen: PropTypes.bool.isRequired,
  onDrawerClose: PropTypes.func.isRequired,
};

export default AppDrawer;
